import React from "react";
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { Line } from "react-chartjs-2";
import {Card, CardHeader, Text} from "@fluentui/react-components";
import { webLightTheme } from '@fluentui/react-components';
import ChartStreaming from "@robloche/chartjs-plugin-streaming";
import { API_PATH } from "../Constants.ts";
import { Chart as ChartJS, LineElement, LinearScale, PointElement} from 'chart.js';
import {ControlPanelNavigation} from "./control-panel-navigation.js";
import {HeartPulse20Regular} from "@fluentui/react-icons";
ChartJS.register(ChartStreaming, LineElement, PointElement, LinearScale);
ChartJS.defaults.defaultFontFamily = "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serifFont family fontFamilyBase";
ChartJS.defaults.defaultFontColor = webLightTheme.colorNeutralForeground1;
const isEmpty = array => Array.isArray(array) && array.length === 0;
const maxPacketIndexDiff = 3;

class Queue {
    _initialize(initialIndex) {
        this.items = [];
        this.index        = initialIndex;
        this.initialIndex = initialIndex;
        this.resetChartFlag = true;

        console.log('new queue initialized with content:');
        console.log('initialIndex: ' + initialIndex);
        console.log('index: ' + this.index);
    }

    constructor() {
        this._initialize(undefined);
    }

    enqueue(item) {
        console.log('enqueue()');

        if (isEmpty(this.items) || item.index < this.initialIndex - maxPacketIndexDiff) {
            console.log('resetting the queue');
            this._initialize(item.index);
        }

        this.items[item.index] = item;
        console.log('inserted item.index: ' + item.index);
    }

    dequeue() {
        console.log('dequeue()');
        if (isEmpty(this.items)) return console.log('queue is empty'), undefined;
        if (this.index >= this.items.length) return console.log('index out of bounds'), undefined;

        const item = this.items[this.index];
        console.log('delete this.items[this.index] where this.index=' + this.index);
                     delete this.items[this.index];
        this.index++;
        console.log('item.computedIntensity=' + item.computedIntensity);
        return item;
    }

    peek = () => this.items[this.index];

    resetChart() {
        return this.resetChartFlag ? (this.resetChartFlag = false, true) : false;
    }
}

export const BiofeedbackChart = () => {
    const { selectedPatientId} = useContext(SelectedPatientContext);
    let startDate = Date.now();
    let queue = new Queue();

    React.useEffect(() => {
        const timer = setInterval(() => {
            if (selectedPatientId===null) return;

            fetch(API_PATH.LOGS + `?limit=2&order[id]=desc&query=(tag=='VR'ANDtitle=='BiofeedbackData'ANDinserted_by_user_id==${encodeURIComponent(selectedPatientId)})&${Math.random()}`).then(
                result => {
                    return result.json();
                }).then(data => {
                    data.forEach(element => {
                        const message = JSON.parse(element.message);
                        console.log('message: ' + JSON.stringify(message));
                        console.log('message.computedIntensity=' + message.computedIntensity);
                        queue.enqueue(message);
                    });
            });
        }, 1000);
        return () => clearInterval(timer);
    });

    const data = {
        datasets: [
            {
                label: "Heart rate [bpm - beats per minute]",
                borderColor: "red",
                fill: false,
                lineTension: 0.25,
                borderWidth: 1,
                pointStyle: 'circle',
                data: []
            },
            {
                label: "Intensity",
                borderColor: "blue",
                fill: false,
                lineTension: 0.25,
                borderWidth: 1,
                pointStyle: 'circle',
                data: []
            }
        ]
    };

    const options = {
        plugins: {
            legend: {
                display: false
            },
            streaming: {
                frameRate: 15
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            line: {
                tension: 0.5
            }
        },
        scales: {
            x: {
                type: "realtime",
                realtime: {
                    onRefresh: function (chart) {
                        console.log('onRefresh()');

                        if (queue.resetChart()) {
                            console.log('resetting the chart');
                            startDate = Date.now();
                            chart.data.datasets[0].data = [];
                            chart.update();
                        }

                        if (queue.peek() === undefined) {
                            console.log('queue is empty or front element is undefined');
                            console.log('queue.index: ' + queue.index);
                            queue.dequeue(); // SKIP
                            return;
                        }

                        const front = queue.dequeue();
                        const packetNumber = Math.abs(front.index-queue.initialIndex);
                        console.log('packet number: ' + packetNumber);
                        console.log('front packet index: ' + front.index);
                        console.log('queue.index: ' + queue.index);

                        console.log('DRAWING: x=' + (startDate + packetNumber*1000) + ' y=' + front.computedIntensity);

                        chart.data.datasets[0].data.push({
                            x: startDate + packetNumber*1000,
                            y: front.heartRate
                        });

                        chart.data.datasets[1].data.push({
                            x: startDate + packetNumber * 1000,
                            y: front.computedIntensity*50+50
                        });
                    },
                    delay: 1000,
                    duration: 120000
                }
            },
            y: {
                ticks: {
                    callback: function (value, index, values) {
                        return value + 'BPM';
                    }
                }
            }
        }
    };

    return (
        <>
            <div className='control-panel-layout'>
                <aside className="sidenav">
                    <ControlPanelNavigation/>
                </aside>
                <Card size='large' className="card" style={{ height: '88vh', margin: '12px' }}>
                    <CardHeader image={<HeartPulse20Regular />} header={<Text weight="semibold">Heart rate [bpm - beats per minute]</Text>} />
                    <Line data={data} options={options}/>
                </Card>
            </div>
        </>
    );
};